import React, {useState, useEffect, useRef, useCallback, useReducer, useMemo} from 'react';
import styled from 'styled-components';

import {DEFAULT_TEXT_SLIDE_BACKGROUND} from "../config";

let getH = () => {
    try {
        return document.getElementsByClassName('treadmill_video_slide_placeholder')[0].clientHeight;
    } catch (exc) {

    }
}

let pauseMediaIfNeeded = (media, currentTime, mediaReplay, isPaused, playbackRate = 10, setPlayTimes = (x) => {}) => {
    if (media == undefined || currentTime == undefined || currentTime < 0 || isPaused == undefined) {
        return;
    }
    let mediaDuration = media.duration;

    if (isNaN(mediaDuration)) {
        media.onloadedmetadata = () => {
            pauseMediaIfNeeded(media, currentTime, mediaReplay, isPaused, playbackRate, setPlayTimes);
        };
        return;
    }

    let actualMediaDuration = mediaDuration / (playbackRate / 10);

    const newPlayTimes = Math.floor(currentTime / actualMediaDuration);
    setPlayTimes(newPlayTimes);

    if (isPaused == false) {
        if (mediaReplay?.shouldReplay == true) {
            if (actualMediaDuration * mediaReplay?.times > currentTime) {
                media.currentTime = currentTime % actualMediaDuration;
                media.play();
            } else {
                media.currentTime = 0;
                media.pause();
            }

        } else {

            if (actualMediaDuration > currentTime) {
                media.currentTime = currentTime * (playbackRate / 10);
                media.play();
            } else {
                media.currentTime = 0;
                media.pause();
            }

        }
    } else {
        media.pause();
    }
}

export default function VideoSlide(props) {
    const {
        id,
        imageSrc,
        coverBackground = false,
        videoTime = 0,
        video = undefined,
        videoSrc,
        videoVolume = 10,
        videoPlaybackRate = 10,
        audio = undefined,
        audioSrc,
        audioVolume = 10,
        audioPlaybackRate = 10,
        currentTime,
        isPreview = false,
        isPaused = false,
        overlayBackground = `rgba(0, 0, 0, 0.4)`,
        backgroundColor = '#000',
        hasBackgroundColor = false,
        textBackgroundColor = '#000',
        hasCountDown = false,
        timeBeforeSlideEnd = 0,

        text = '',

        textColor = 'white',
        textSize = 12, // in percents

        textPosition = 'center' // top, center, bottom
    } = props;

    let actualTime = currentTime - +props.from;
    let hasAudio = audioSrc !== undefined && audioSrc !== '';
    
    const [audioPlayTimes, setAudioPlayTimes] = useState(0);
    const [videoPlayTimes, setVideoPlayTimes] = useState(0);
    const [height, setHeight] = useState();

    useEffect(() => {
        if (height == undefined) {
            setHeight(getH());
        }
        if (audio) {
            if (audioSrc) {
                audio.src = audioSrc;
            } else {
                audio.pause();
            }
        }
        if (video) {
            let videoPlaceholder = document.getElementById('treadmill_video_placeholder');
            videoPlaceholder.appendChild(video);
            video.src = videoSrc;
            video.volume = videoVolume / 10;
            video.playbackRate = videoPlaybackRate / 10;
        }
    }, []);
    
    if (video) {
        video.height = height;
    }

    let fontSize = height * textSize / 100.0;
    let lineHeight = 1.2 * fontSize;

    useEffect(() => {
        if (video) {
            pauseMediaIfNeeded(video, videoTime, props?.videoReplay, isPaused, videoPlaybackRate, (x) => setVideoPlayTimes(x));
        }
        if (audio && audioSrc) {
            pauseMediaIfNeeded(audio, videoTime, props?.audioReplay, isPaused, audioPlaybackRate, (x) => setAudioPlayTimes(x));
        }
    }, [videoTime, id]);

    useEffect(() => {
        if (video) {
            if (actualTime == 0 && isPaused == false) {
                video.play();
            } else {
                pauseMediaIfNeeded(video, actualTime, props?.videoReplay, isPaused, videoPlaybackRate, (x) => setVideoPlayTimes(x));
            }
        }
        if (audio && audioSrc) {
            if (actualTime == 0 && isPaused == false) {
                audio.play();
            }
            pauseMediaIfNeeded(audio, actualTime, props?.audioReplay, isPaused, audioPlaybackRate, (x) => setAudioPlayTimes(x));
        }
    }, [video, audio, id])

    useEffect(() => {
        if (audio) {
            audio.playbackRate = audioPlaybackRate / 10;
            audio.volume = audioVolume / 10;
        }
    }, [audio, audioVolume, audioPlaybackRate, id]);

    useEffect(() => {
        if (video) {
            video.volume = videoVolume / 10;
            video.playbackRate = videoPlaybackRate / 10;
            if (videoVolume > 0) {
                video.muted = false;
            } else {
                video.muted = true;
            }
        }
    }, [video, videoVolume, videoPlaybackRate, id])

    useEffect(() => {
        if (isPaused === false) {
            if (audio && audioSrc) {
                pauseMediaIfNeeded(audio, actualTime, props?.audioReplay, isPaused, audioPlaybackRate, (x) => setAudioPlayTimes(x));
            }

            if (video) {
                pauseMediaIfNeeded(video, actualTime, props?.videoReplay, isPaused, videoPlaybackRate, (x) => setVideoPlayTimes(x));
            }
        } else {
            video?.pause();
            audio?.pause();
        }
    }, [isPaused, id])

    const handleAudioEnd = () => {
        if (props?.audioReplay?.shouldReplay == true) {
            setAudioPlayTimes((prevTimes) => {
                if (prevTimes < +props?.audioReplay?.times - 1) {
                    audio.currentTime = 0;
                    if (isPaused === false && audioSrc) {
                        audio.play();
                    }
                    return prevTimes + 1;
                } else {
                    audio.pause();
                    return 0;
                }
            })
        }
    }

    const handleVideoEnd = () => {
        if (props?.videoReplay?.shouldReplay == true) {
            setVideoPlayTimes((prevTimes) => {
                if (prevTimes < +props?.videoReplay?.times - 1) {
                    video.currentTime = 0;
                    if (isPaused === false && videoSrc) {
                        video.play();
                    }
                    return prevTimes + 1;
                } else {
                    video.pause();
                    return 0;
                }
            })
        }
    }

    useEffect(() => {
        if (audio) {
            audio.addEventListener('ended', handleAudioEnd);
        }

        return () => {
            if (audio) {
                audio.removeEventListener('ended', handleAudioEnd);
            }
        }
    }, [audioPlayTimes, id])

    useEffect(() => {
        if (video) {
            video.addEventListener('ended', handleVideoEnd);
        }

        return () => {
            if (video) {
                video.removeEventListener('ended', handleVideoEnd);
            }
        }
    }, [videoPlayTimes, id])

    return (
        <Wrapper className='treadmill_video_slide_placeholder'>
            {coverBackground == false ? null :
                <Cover backgroundColor={backgroundColor} />
            }
            {imageSrc == undefined || imageSrc == '' ? null :
                <Image src={imageSrc} />
            }
            <VideoPlaceholder id='treadmill_video_placeholder'>
                {video != undefined ? null :
                    <Video
                        className={'treadmill_video_slide_video'}
                        controls={isPreview}
                        autoPlay={!isPaused && !isPreview}
                        playsInline
                        src={videoSrc}
                    />
                }
            </VideoPlaceholder>
            <TextLayerPlaceholder textPosition={textPosition}>
                <Text style={{
                    fontSize: `${fontSize}px`,
                    lineHeight: `${lineHeight}px`,
                    color: textColor,
                    backgroundColor: hasBackgroundColor ? textBackgroundColor : 'transparent'
                }}>
                    <div dangerouslySetInnerHTML={{__html: `${text}`}}></div>
                </Text>
                
            </TextLayerPlaceholder>
            {hasAudio === false || audio != undefined || isPreview ? null :
                <audio key={id} className={'treadmill_video_slide_audio'} autoPlay={!isPaused} preload='none' playsInline>
                    <source src={`${audioSrc + `#t=${videoTime}`}`}/>
                </audio>
            }
        </Wrapper>
    );
}

const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: relative;
  background-color: ${props => (props.background == undefined ? DEFAULT_TEXT_SLIDE_BACKGROUND : props.background)};
`;

const VideoPlaceholder = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 0;
`;

const Video = styled.video`
  height: 100%;
  //width: 100%;
  max-width: 100%;
  background: black;
  max-height: 100%;
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  object-fit: contain;
  z-index: 0;
`;

const TextLayerPlaceholder = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  z-index: 5;
  justify-content: ${props => ({'top': 'flex-start', 'bottom': 'flex-end', 'center': 'center'}[props.textPosition])};
`;

const Text = styled.div`
  text-align: center;
  z-index: 10;
`;

const Image = styled.img`
  position: absolute;
  width: 100%;
  min-height: 100%;
  z-index: 1;
`;

const Cover = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${props => props.backgroundColor};
    position: absolute;
    z-index: 2;
`;